export const MessageChannelOptions = {
  GroupMessage: 'Create channel',
  MassMessage: 'Mass direct message',
};

export const MAX_CHARACTERS_LIMIT = 5000;
export const MAX_CHARACTERS_LIMIT_ERROR =
  'Your message exceeds the 5000 character limit';

export const getCharacterLimitError = (characterCount: number): string =>
  `${MAX_CHARACTERS_LIMIT_ERROR} (${characterCount.toLocaleString()} / ${MAX_CHARACTERS_LIMIT.toLocaleString()})`;
